import SpEditMenuItemValue from 'src/components/SpEditMenuItemValue';
import { capitalize } from '@utils/capitalize';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const SingleBowl = () => {
  const { t } = useTranslation();
  return <SpEditMenuItemValue value={capitalize(t('single_bowl'))} />;
};
